import { useEffect } from 'react'

interface PageMeta {
  title: string
  description: string
  image?: string
  url?: string
  type?: 'website' | 'article'
}

const SITE_NAME = 'Belo Digital'
const DEFAULT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/qZq5o2kR7qajKU24kpFCJC/blogo.svg'

function setMetaTag(property: string, content: string, isName = false) {
  const attr = isName ? 'name' : 'property'
  let el = document.querySelector(
    `meta[${attr}="${property}"]`,
  ) as HTMLMetaElement | null
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, property)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export function usePageMeta({
  title,
  description,
  image,
  url,
  type = 'website',
}: PageMeta) {
  useEffect(() => {
    const fullTitle = title === SITE_NAME ? title : `${title} | ${SITE_NAME}`
    const pageUrl = url || window.location.href
    const pageImage = image || DEFAULT_IMAGE

    // Browser tab title
    document.title = fullTitle

    // Standard meta
    setMetaTag('description', description, true)

    // Open Graph
    setMetaTag('og:title', fullTitle)
    setMetaTag('og:description', description)
    setMetaTag('og:image', pageImage)
    setMetaTag('og:url', pageUrl)
    setMetaTag('og:type', type)
    setMetaTag('og:site_name', SITE_NAME)

    // Twitter Card
    setMetaTag('twitter:card', image ? 'summary_large_image' : 'summary', true)
    setMetaTag('twitter:title', fullTitle, true)
    setMetaTag('twitter:description', description, true)
    setMetaTag('twitter:image', pageImage, true)

    return () => {
      document.title = SITE_NAME
    }
  }, [title, description, image, url, type])
}
